import React from "react";

export function DiscountToggleRow({
  isOn,
  title,
  hint,
  children,
  footer = null,
  className = "",
}) {
  return (
    <div
      className={`discount-toggle-block${isOn ? " is-on" : ""}${className ? ` ${className}` : ""}`}
    >
      <div className="discount-toggle-row">
        <div className="discount-toggle-row__copy">
          <p className="discount-toggle-row__title">{title}</p>
          {hint ? <p className="discount-toggle-row__hint">{hint}</p> : null}
        </div>
        <div className="discount-toggle-row__control">{children}</div>
      </div>
      {footer ? <div className="discount-toggle-block__body">{footer}</div> : null}
    </div>
  );
}

export function DiscountSection({ icon, label, children, nested = false }) {
  return (
    <section className={`discount-form-section${nested ? " discount-form-section--nested" : ""}`}>
      {label ? (
        <h2 className="discount-form-section__label">
          {icon ? (
            <span className="discount-form-section__label-icon" aria-hidden="true">
              <i className={`fa ${icon}`} />
            </span>
          ) : null}
          {label}
        </h2>
      ) : null}
      {children}
    </section>
  );
}

export function DiscountRuleCard({ selected, icon, title, description, onSelect }) {
  return (
    <button
      type="button"
      className={`discount-rule-card${selected ? " is-selected" : ""}`}
      onClick={onSelect}
      aria-pressed={selected}
    >
      <span className="discount-rule-card__icon" aria-hidden="true">
        <i className={`fa ${icon}`} />
      </span>
      <span>
        <p className="discount-rule-card__title">{title}</p>
        <p className="discount-rule-card__desc">{description}</p>
      </span>
    </button>
  );
}

export function DiscountChip({ icon, name, onRemove, imageSrc }) {
  return (
    <div className="discount-chip">
      <span className="discount-chip__icon" aria-hidden="true">
        {imageSrc ? (
          <img
            src={imageSrc}
            alt=""
            style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "0.45rem" }}
          />
        ) : (
          <i className={`fa ${icon || "fa-tag"}`} />
        )}
      </span>
      <span className="discount-chip__name" title={name}>
        {name}
      </span>
      {onRemove ? (
        <button
          type="button"
          className="discount-chip__remove"
          onClick={onRemove}
          aria-label={`Remove ${name}`}
        >
          <i className="fa fa-times" />
        </button>
      ) : null}
    </div>
  );
}

export function DiscountEmptyState({ icon, text, actionLabel, onAction }) {
  return (
    <div className="discount-empty">
      <div className="discount-empty__icon" aria-hidden="true">
        <i className={`fa ${icon}`} />
      </div>
      <p className="discount-empty__text">{text}</p>
      {actionLabel && onAction ? (
        <button type="button" className="discount-btn-accent" onClick={onAction}>
          <i className="fa-solid fa-plus" aria-hidden="true" />
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
}
